import React from 'react'
import gatewayImage from 'src/images/gateway-modal-logo.jpg'
import logo from 'src/images/logo-black2.png'
import modalBackground from 'src/images/gateway-modal-bg-mobile.jpg'
import { ContentGrid, ContentGridItem, LogoWrapper, StyledDialog } from './GatewayModal.styled'
import { Theme, useMediaQuery, useTheme } from '@mui/material'
import Image from 'next/image'

interface Props {
  isVisible: boolean
  children: React.ReactNode
}

const GatewayModal: React.FC<Props> = ({ isVisible, children }) => {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))
  const theme = useTheme<Theme>()
  const isMobileLandscape = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px) and (orientation: landscape)`)

  return (
    <StyledDialog fullWidth open={isVisible} maxWidth="md">
      <ContentGrid container direction={!isMobile ? 'row' : 'column'}>
        {!isMobile && <Image src={gatewayImage.src} width={300} height={600} alt="Charleston Wrap Gateway" />}
        {isMobile && !isMobileLandscape && (
          <Image
            src={modalBackground.src}
            width={0}
            height={0}
            sizes="100vw"
            style={{ width: '100%', height: 'auto', maxHeight: '25vh', objectFit: 'cover', flexShrink: 0 }}
            alt="Charleston Wrap Modal Background"
          />
        )}
        <ContentGridItem>
          {children}
          {!isMobile && (
            <LogoWrapper>
              <Image sizes="100vw" width={160} height={36} src={logo.src} alt="Charleston Wrap Logo" />
            </LogoWrapper>
          )}
        </ContentGridItem>
      </ContentGrid>
    </StyledDialog>
  )
}

export default GatewayModal
